import React from "react";
import { useNavigate } from "react-router";

function BackBtn(props: any) {
  const navigate = useNavigate();
  return (
    <button
      className="button backbutton circle d-flex justify-content-center align-items-center"
      onClick={() => props.backActionClick()}>
      <span className="material-symbols-outlined">arrow_back</span>
    </button>
  );
}

export default BackBtn;
